<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-24 11:33:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-25 18:20:13
-->
<template>
  <!-- 密码强度 -->
  <div>
    <div v-if="$route.name == 'passwordIntensity'">
      <mrc_ess_skeleton_loader :loading="skLoading">
        <v-card>
          <v-card-text class="pa-8">
            <div class="text--secondary pb-3 pl-10">
              <!-- {{$t('label_client')}}/{{$t('label_company_unit')}} -->
              {{$t('label_pinSecurity_m_name')}}
            </div>
            <template v-if="Array.isArray(companyList) && companyList.length > 0">
              <!-- <parent-company v-for="item in companyList"
                              :key="item.uuid"
                              @delData="delData"
                              :companyObj="item" /> -->
              <v-treeview hoverable
                          open-on-click
                          transition
                          selected-color="primary"
                          item-key="uuid"
                          item-children="children"
                          expand-icon="arrow_drop_down"
                          :items="companyList">
                <template v-slot:label="{ item }">
                  {{ INT(item.org_level_name) }}
                </template>
                <template v-slot:append="{ item }">
                  <menu-list :list="[
                      {
                        name: $t('label_View'),
                        show: hasBtn('view-platform-password-policy'),
                        type: 'view',
                      },
                      {
                        name: $t('label_Edit'),
                        show: hasBtn('edit-platform-password-policy'),
                        type: 'edit',
                      },
                    ]"
                             @handleClick="handleClick($event, item)">
                    <template v-slot:showAction>
                      <v-icon v-btnAuth="[
                          'view-platform-password-policy',
                          'edit-platform-password-policy',
                        ]">mdi-dots-vertical</v-icon>
                    </template>
                  </menu-list>
                </template>
              </v-treeview>
            </template>
            <template v-else>
              <mrc_ess_noContent></mrc_ess_noContent>
            </template>
          </v-card-text>
        </v-card>
      </mrc_ess_skeleton_loader>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { get_company_list, get_company_del } from '@/service/api/company_set'
export default {
  components: {},
  props: {},
  data () {
    return {
      companyList: [],
      skLoading: true,
    }
  },
  async created () {
    await this.getBtnPermissionList()
  },
  async mounted () {
    if (this.$route.name == 'passwordIntensity') {
      await this.getBtnPermissionList()
      await this.getList()
      this.skLoading = false
    }
  },
  methods: {
    delData (uuid) {
      this.Recursion(this.companyList, uuid)
    },
    Recursion (arr, uuid) {
      if (Array.isArray(arr) && arr.length <= 0) return ''
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1)
        } else {
          if (item.children) {
            this.Recursion(item.children, uuid)
          }
        }
      })
    },
    // 获取公司列表
    async getList () {
      this.skLoading = true
      const list = await get_company_list({
        client_uuid: this.$store.state.userData.clientUuid,
      })
      if (list.code == 200) {
        this.companyList = list.data
      }
      this.skLoading = false
    },
    handleClick ({ item, index }, obj) {
      switch (item.type) {
        case 'view':
          this.$store.commit('set_iconstatus', true) //行内进图标显示
          this.$store.commit('set_subPage_name', obj.org_level_name)
          this.$store.commit('set_uuid', obj.uuid)
          this.$store.commit('setOrgLevelCode', obj.org_level_code)
          this.$router.push({
            name: 'detailPasswordIntensity',
            params: {
              name: obj.org_level_name,
              uuid: obj.uuid,
            },
          })
          break
        case 'edit':
          this.$store.commit('set_iconstatus', false) //行内进图标显示
          this.$store.commit('set_subPage_name', obj.org_level_name)
          this.$store.commit('set_uuid', obj.uuid)
          this.$store.commit('setOrgLevelCode', obj.org_level_code)
          this.$router.push({
            name: 'detailPasswordIntensity',
            params: {
              name: obj.org_level_name,
              uuid: obj.uuid,
            },
          })
          break
      }
    },
  },
  computed: {},
  watch: {
    async $route (val) {
      if (val.name == 'passwordIntensity') {
        await this.getList()
        this.$store.commit('setTab', 0)
      }
    },
  },
}
</script>

<style scoped>
/deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}

/* /deep/ .v-treeview {
  border-radius: 8px;
} */
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
}
</style>
